import { toDayKey, todayKey } from './dates';

export const orderSubtotal = (order) => {
  if (order.subtotal != null) return Number(order.subtotal);
  return (order.items || []).reduce(
    (s, i) => s + (Number(i.price) || 0) * (Number(i.qty) || 1),
    0,
  );
};

export const deliveredOrderDayKey = (order) => {
  const t = order?.deliveredAt?.toDate?.()
    || order?.updatedAt?.toDate?.()
    || order?.createdAt?.toDate?.();
  return t ? toDayKey(t) : null;
};

export const isDeliveredForShop = (order, shopId) =>
  order.status === 'delivered' && order.shopId === shopId;

export const computeMerchantBalance = (orders, payouts, shopId) => {
  const deliveredSubtotal = orders
    .filter((o) => isDeliveredForShop(o, shopId))
    .reduce((s, o) => s + orderSubtotal(o), 0);

  const paidOut = payouts
    .filter((p) => p.merchantId === shopId && p.status === 'paid')
    .reduce((s, p) => s + (Number(p.amount) || 0), 0);

  return Math.max(0, deliveredSubtotal - paidOut);
};

export const computeDailyMerchantOwed = (orders, shopId, dayKey) =>
  orders
    .filter((o) => isDeliveredForShop(o, shopId) && deliveredOrderDayKey(o) === dayKey)
    .reduce((s, o) => s + orderSubtotal(o), 0);

export const countDailyDeliveredOrders = (orders, shopId, dayKey) =>
  orders.filter((o) => isDeliveredForShop(o, shopId) && deliveredOrderDayKey(o) === dayKey).length;

export const weekStartKey = (dayKey = todayKey()) => {
  const [y, m, d] = dayKey.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  const day = date.getUTCDay();
  const diff = day === 0 ? 6 : day - 1;
  date.setUTCDate(date.getUTCDate() - diff);
  return toDayKey(date);
};

export const isOnOrAfterDay = (dayKey, startKey) => dayKey >= startKey;

export const sumDeliveredSubtotalSince = (orders, shopId, startKey) =>
  orders
    .filter((o) => {
      if (!isDeliveredForShop(o, shopId)) return false;
      const dk = deliveredOrderDayKey(o);
      return dk && isOnOrAfterDay(dk, startKey);
    })
    .reduce((s, o) => s + orderSubtotal(o), 0);
